module.exports = __webpack_public_path__ + "static/harvard.ae3b641e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/harvard.png
// module id = 147
// module chunks = 35783957827783 226020273838829